import { DEFAULT_CHINA_LOCALE } from '../../constants';

/**
 * Prepends the specified locale to a relative URL if it is not already present.
 *
 * @param url - The URL to which the locale should be appended.
 * @param locale - The locale to append to the URL. If not provided, the URL is returned as is.
 * @returns The relative URL with the locale prepended, or the original URL if the locale is not provided or already present.
 */
export const appendLocaleToRelativeUrl = (url: string, locale?: string): string => {
  if (!locale || !url.startsWith('/')) return url;

  const urlLowerCased = url.toLocaleLowerCase();
  const localeLowerCased = locale.toLocaleLowerCase();
  const chinaLocaleLowerCased = DEFAULT_CHINA_LOCALE.toLocaleLowerCase();

  const isChinaLocale = localeLowerCased === chinaLocaleLowerCased;

  if (!isChinaLocale && !urlLowerCased.startsWith(`/${localeLowerCased}`)) {
    return `/${locale}${url}`;
  }

  if (isChinaLocale && urlLowerCased.startsWith(`/${chinaLocaleLowerCased}`)) {
    const caseInsensitiveChinaLocale = new RegExp(`^/${DEFAULT_CHINA_LOCALE}`, 'i');
    return url.replace(caseInsensitiveChinaLocale, '');
  }

  return url;
};
